import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

export const teamAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30 },
  { name: 'headline', type: 'string', required: true, max: 80 },
  { name: 'subheadline', type: 'string', required: false, max: 200 },
  {
    name: 'members',
    type: 'array<object>',
    required: true,
    fields: [
      { name: 'name', type: 'string', required: true, max: 40 },
      { name: 'role', type: 'string', required: true, max: 60 },
      { name: 'bio', type: 'string', required: false, max: 200 },
      { name: 'avatar', type: 'image_url', required: false },
    ],
  },
];

export const teamUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'Eyebrow', max: 30 },
  { name: 'headline', type: 'text', label: 'Headline', required: true, max: 80 },
  { name: 'subheadline', type: 'textarea', label: 'Subheadline', max: 200 },
  { name: 'members', type: 'team_list', label: 'Members', required: true },
];

export const teamZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  headline: z.string().min(1).max(80),
  subheadline: z.string().max(200).optional().nullable(),
  members: z
    .array(
      z.object({
        name: z.string().max(40),
        role: z.string().max(60),
        bio: z.string().max(200).optional().nullable(),
        avatar: z.string().optional().nullable(),
      }),
    )
    .min(1)
    .max(12),
});

export type TeamContent = z.infer<typeof teamZodSchema>;

export const teamSample: TeamContent = {
  eyebrow: 'The team',
  headline: 'The humans behind the work.',
  subheadline: 'Designers, engineers, and operators who genuinely love this craft.',
  members: [
    { name: 'Aiko Tanaka', role: 'Co-founder · Design', bio: 'Previously led design at Lumen.', avatar: null },
    { name: 'Marcus Reid', role: 'Co-founder · Engineering', bio: 'Built infrastructure at three startups.', avatar: null },
    { name: 'Priya Shah', role: 'Head of Customer', bio: 'Spent 10 years on the studio side of the table.', avatar: null },
    { name: 'Diego Alvarez', role: 'Engineering', bio: 'Compiler nerd. Coffee obsessive.', avatar: null },
  ],
};
